import React from 'react';
import {Checkbox, type CheckboxProps} from '@mui/material';
import {type HeaderContext, type RowData} from '@tanstack/react-table';
import {splitEventHandler} from '@netx/core-next/index';
import {i18n} from '@netx/core-next/locales/i18n-instance';

export interface HeaderSelectionCellProps<
	TData extends RowData,
> extends HeaderContext<TData, any> {
	CheckboxProps?: CheckboxProps;
}

export const HeaderSelectionCellPrimative = <TData extends RowData>({
	table,
	CheckboxProps,
}: HeaderSelectionCellProps<TData>) => {
	return (
		<Checkbox
			title={i18n.t('i18n.selectAll')}
			disabled={table.getRowModel().rows?.length === 0}
			checked={table.getIsAllRowsSelected()}
			indeterminate={table.getIsSomeRowsSelected()}
			tabIndex={0}
			{...CheckboxProps}
			onChange={splitEventHandler(
				CheckboxProps?.onChange,
				table.getToggleAllRowsSelectedHandler(),
			)}
			onBlur={splitEventHandler(CheckboxProps?.onBlur, (event) => {
				event.stopPropagation();
			})}
			onFocus={splitEventHandler(CheckboxProps?.onFocus, (event) => {
				event.stopPropagation();
			})}
		/>
	);
};

export const HeaderSelectionCell = HeaderSelectionCellPrimative;

export default HeaderSelectionCell;
